import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import LocalizationPaginationRequest from '../../../RunPay/Admin/IServices/Models/LocalizationPaginationRequest';
import SaveMainSliderItemRequest from '../../../RunPay/Admin/IServices/Models/MainSliderItem/SaveMainSliderItemRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import MainSliderPublicItemResponse from '../../../RunPay/Admin/IServices/Models/MainSliderItem/MainSliderPublicItemResponse';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import MainSliderItemResponse from '../../../RunPay/Admin/IServices/Models/MainSliderItem/MainSliderItemResponse';
import BaseResponse from '../../../Common/ResponseModels/BaseResponse';

export default class MainSliderService {
	webApiService: WebApiService;
	GetListAllEvent = new Events<WsResponseModel<Array<MainSliderPublicItemResponse>>>();
	GetPaginatedListEvent = new Events<WsResponseModel<PaginationResponse<MainSliderItemResponse>>>();
	SaveEvent = new Events<WsResponseModel<number>>();
	DeleteEvent = new Events<WsResponseModel<BaseResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('MainSliderService', 'GetListAll', (res: WsResponseModel<Array<MainSliderPublicItemResponse>>) => {
			self.GetListAllEvent.trigger(res);
		});
		webApiService.on('MainSliderService', 'GetPaginatedList', (res: WsResponseModel<PaginationResponse<MainSliderItemResponse>>) => {
			self.GetPaginatedListEvent.trigger(res);
		});
		webApiService.on('MainSliderService', 'Save', (res: WsResponseModel<number>) => {
			self.SaveEvent.trigger(res);
		});
		webApiService.on('MainSliderService', 'Delete', (res: WsResponseModel<BaseResponse>) => {
			self.DeleteEvent.trigger(res);
		});
	}
	GetListAll(langCode?: string = '') { 	
        this.webApiService.send('MainSliderService', 'GetListAll' , langCode);
    }
	GetPaginatedList(request: LocalizationPaginationRequest = null) { 	
        this.webApiService.send('MainSliderService', 'GetPaginatedList' , request);
    }
	Save(request: SaveMainSliderItemRequest = null) { 	
        this.webApiService.send('MainSliderService', 'Save' , request);
    }
	Delete(id: number = 0) { 	
        this.webApiService.send('MainSliderService', 'Delete' , id);
    }
	 // async methods
	async getListAllAsync(langCode: string = ''): Promise<Array<MainSliderPublicItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetListAll.bind(this), this.GetListAllEvent)(langCode);
	}
	async getPaginatedListAsync(request: LocalizationPaginationRequest = null): Promise<PaginationResponse<MainSliderItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedList.bind(this), this.GetPaginatedListEvent)(request);
	}
	async saveAsync(request: SaveMainSliderItemRequest = null): Promise<number> {
		return EventToAsyncDecorator.getInstance().bind(this.Save.bind(this), this.SaveEvent)(request);
	}
	async deleteAsync(id: number = 0): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/MainSliderService.ts